export default {"src":"/_next/static/media/deloitte.884acf98.svg","height":41,"width":214,"blurWidth":0,"blurHeight":0};